// 高德地图key

export const MAPKEY = "756672bc7e7eeb1db79b97512947983f";

// 默认显示城市

// export const MAPCITYNMANE = "秦皇岛";

// 高德地图版本

export const AMAPVERSION = "2.0";

//高德地图UI版本

export const AMAPUIVERSION = "1.1";
